import { FC } from 'react';
import { Typography, Box, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Section } from 'src/components/section';
import { ReactComponent as BackArrow } from 'src/assets/svg/back-arrow.svg';
import { RoommateForm } from 'src/features/multi-occupancy';
import { theme } from 'src/styles/theme';

import { styles } from './styles';
import { RoommatesViewProps } from './types';

export const RoommatesView: FC<RoommatesViewProps> = ({
    onGoBack,
    onSubmit,
    isPending,
    basket,
    numberOfStudents,
}) => {
    const { t } = useTranslation();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));

    return (
        <Box css={styles.layout}>
            {!isSmallScreen && (
                <Box css={styles.back} onClick={onGoBack}>
                    <BackArrow css={styles.icon} />
                    <Typography>{t('agreements_back_button_content')}</Typography>
                </Box>
            )}

            <Section header={t('roommates_title')}>
                <Typography variant="body3">{t('roommates_subheader')}</Typography>
            </Section>

            <RoommateForm
                onFormSubmit={onSubmit}
                loading={isPending}
                roommates={basket ? basket.room_mates : null}
                numberOfStudents={numberOfStudents}
            />

            {isSmallScreen && (
                <Box css={styles.back} onClick={onGoBack} id="roommate-back">
                    <Typography>{t('agreements_back_content')}</Typography>
                </Box>
            )}
        </Box>
    );
};
